import React from 'react';

const SingpassReg = () => {
  return (
    <div>
      <h1>Singpass Registration</h1>
      <p>This is the end of the flow for Singpass Registration.</p>
    </div>
  );
};

export default SingpassReg;